import {
    Box,
    Button,
    MenuItem,
    Popover,
    Stack,
    Typography,
} from "@mui/material";
import React from "react";
import styles from "../../styles/pages/mymessage.module.scss";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import CalenderIcon from "../../ui/Icons/CalenderIcon";
import useFetch from "../../hooks/api/useFetch";
import {
    getMonthFromValue,
    getMonthRange,
    getYearRange,
} from "../../lib/functions/utils.lib";
import ClearICrossIcon from "../../ui/Icons/ClearICrossIcon";
import ApplyFilterIcon from "../../ui/Icons/ApplyFilterIcon";

const statusFilters = [
    { value: 0, label: "Pending" },
    { value: 1, label: "Approved" },
    { value: 2, label: "Rejected" },
];

const HeaderMessageCreation = ({
    status,
    month,
    year,
    handleStatusChange,
    handleMonthChange,
    handleYearChange,
    handleArchiveToggle,
    filters,
    resetFilters,
    applyFilters,
}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    return (
        <Stack
            direction="row"
            alignItems="center"
            flexWrap="wrap"
            className={styles.messageHeader}
        >
            <Select
                value={status}
                onChange={handleStatusChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                            borderRadius: "7px",
                            marginTop: "5px",

                            "& .MuiMenuItem-root": {
                                padding: 0,
                                fontSize: "11px",
                                fontWeight: "500",
                                color: "#525050",
                                lineHeight: "1",
                                "&:hover": {
                                    backgroundColor: "#ffffff",
                                    color: "#111ae9",
                                },
                                "&:not(:last-child)": {
                                    marginBottom: "10px",
                                },

                                "&:first-child": {
                                    display: "none",
                                },
                            },
                            "& .Mui-selected": {
                                background: "#fff !important",
                            },

                            "& .MuiList-root": {
                                padding: "20px 14px",
                                minWidth: "134px",
                            },
                        },
                    },
                }}
                renderValue={() => {
                    return (
                        <span>
                            {status === 2
                                ? "Rejected"
                                : status === 0
                                ? "Pending"
                                : status === 1
                                ? "Approved"
                                : "Status"}
                        </span>
                    );
                }}
            >
                {statusFilters.map((item, index) => {
                    return item?.value !== status ? (
                        <MenuItem key={index} value={item?.value}>
                            {item?.label}
                        </MenuItem>
                    ) : null;
                })}
            </Select>
            <Box className={styles.creationDate}>
                <Button
                    aria-describedby={id}
                    variant="contained"
                    onClick={handleClick}
                    endIcon={<CalenderIcon />}
                >
                    {month || year
                        ? `${month ? getMonthFromValue(month) : ""} ${
                              year ? year : ""
                          }`
                        : "Creation Date"}
                </Button>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                    }}
                    PaperProps={{
                        sx: {
                            boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                            borderRadius: "7px",
                            marginTop: "5px",
                            padding: "24px",
                            maxWidth: "254px",
                            width: "100%",
                            "& .MuiTypography-caption": {
                                fontWeight: "500",
                                fontSize: "13px",
                                color: "#494949",
                                marginBottom: "8px",
                                display: "block",
                            },
                        },
                    }}
                >
                    <Typography variant="caption">Created in</Typography>
                    <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        className={styles.selectDate}
                    >
                        <Select
                            value={month}
                            onChange={handleMonthChange}
                            displayEmpty
                            inputProps={{
                                "aria-label": "Without label",
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        boxShadow:
                                            "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                        borderRadius: "7px",
                                        marginTop: "5px",

                                        "& .MuiMenuItem-root": {
                                            padding: 0,
                                            fontSize: "11px",
                                            fontWeight: "500",
                                            color: "#525050",
                                            lineHeight: "1",
                                            "&:hover": {
                                                backgroundColor: "#ffffff",
                                                color: "#111ae9",
                                            },
                                            "&:not(:last-child)": {
                                                marginBottom: "10px",
                                            },
                                            "&:first-child": {
                                                display: "none",
                                            },
                                        },
                                        "& .Mui-selected": {
                                            background: "#fff !important",
                                        },

                                        "& .MuiList-root": {
                                            padding: "20px 14px",
                                        },
                                    },
                                },
                            }}
                            renderValue={() => {
                                if (month)
                                    return (
                                        <span>{getMonthFromValue(month)}</span>
                                    );
                                return <span>Month</span>;
                            }}
                        >
                            {getMonthRange().map((item, index) => {
                                return item?.value !== month ? (
                                    <MenuItem value={item?.value} key={index}>
                                        {item?.month}
                                    </MenuItem>
                                ) : null;
                            })}
                        </Select>
                        <Select
                            value={year}
                            onChange={handleYearChange}
                            displayEmpty
                            inputProps={{
                                "aria-label": "Without label",
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        boxShadow:
                                            "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                        borderRadius: "7px",
                                        marginTop: "5px",

                                        "& .MuiMenuItem-root": {
                                            padding: 0,
                                            fontSize: "11px",
                                            fontWeight: "500",
                                            color: "#525050",
                                            lineHeight: "1",
                                            "&:hover": {
                                                backgroundColor: "#ffffff",
                                                color: "#111ae9",
                                            },
                                            "&:not(:last-child)": {
                                                marginBottom: "10px",
                                            },
                                            "&:first-child": {
                                                display: "none",
                                            },
                                        },
                                        "& .Mui-selected": {
                                            background: "#fff !important",
                                        },

                                        "& .MuiList-root": {
                                            padding: "20px 14px",
                                        },
                                    },
                                },
                            }}
                            renderValue={() => {
                                if (year) return <span>{year}</span>;
                                return <span>Year</span>;
                            }}
                        >
                            {getYearRange().map((item, index) => {
                                return item.value !== year ? (
                                    <MenuItem value={item.value} key={index}>
                                        {item.year}
                                    </MenuItem>
                                ) : null;
                            })}
                        </Select>
                    </Stack>
                </Popover>
            </Box>
            <Button
                className={styles.btnArchive}
                onClick={() => handleArchiveToggle()}
            >
                Archive
            </Button>
            {filters &&
            filters?.status === status &&
            filters?.month === month &&
            filters?.year === year ? (
                <Button
                    onClick={() => resetFilters()}
                    startIcon={<ClearICrossIcon />}
                    className={styles.filterAplyBtn}
                >
                    Clear All
                </Button>
            ) : status.toString() || (month && year) ? (
                <Button
                    onClick={() => applyFilters()}
                    startIcon={<ApplyFilterIcon />}
                    className={styles.filterAplyBtn}
                >
                    Apply Filters
                </Button>
            ) : (
                ""
            )}
        </Stack>
    );
};

export default HeaderMessageCreation;
